import { createReducer, on } from '@ngrx/store';
import { ViewedDriverLicense } from '../../../models/document.model';
import { driverLicenseActions } from './driver_license.actions';

export interface DriverLicenseViewState {
    data: ViewedDriverLicense | null;
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DriverLicenseViewState = {
    data: null,
    state: 'pending',
};

export const driverLicenseReducer = createReducer(
    initialState,
    on(driverLicenseActions.loadViewSuccess, (state, { payload }) => ({ ...state, data: payload, state: 'loaded' as const })),
    on(driverLicenseActions.loadExtractionInfoSuccess, (state, { payload }) => ({ ...state, data: payload, state: 'loaded' as const })),
    on(driverLicenseActions.clearView, () => initialState),
    on(driverLicenseActions.editExtractionSuccess, (state, { payload }) => ({
        ...state,
        data: state.data ? { ...state.data, extracted_license: payload } : state.data,
    }))
);
